module.exports = __webpack_public_path__ + "img/daolan.4195316c.jpg";